import React from 'react';
import { useRouter } from '@tanstack/react-router';
import {
  BaseOwnerSwitcher,
  NavSection,
  NavItem
} from '@rhino-project/ui-heroui';
import { TeamSwitcher } from '../../app/TeamSwitcher';
import { useNavigation } from '../hooks/useNavigation';
import { NavActionItem } from './NavActionItem';
import { ModeSwitcher } from '../../nav/ModeSwitcher';
import { useMode } from '../../../hooks/useMode';

export function PrimaryNavbar(): React.ReactNode {
  const { sections } = useNavigation();
  const { mode } = useMode();
  const router = useRouter();

  const handleOwnerChange = (key: string) => {
    const nextOwner = String(key);
    if (mode === 'plan') {
      router.navigate({ to: '/$owner/plan', params: { owner: nextOwner } });
    } else {
      router.navigate({ to: '/$owner', params: { owner: nextOwner } });
    }
  };

  return (
    <nav className="h-full flex flex-col justify-start p-4">
      <div className="flex flex-col gap-2 mb-4">
        <BaseOwnerSwitcher onChange={handleOwnerChange} />
        <TeamSwitcher />
      </div>
      <div className="mb-6">
        <ModeSwitcher />
      </div>
      <ul className="flex flex-col gap-2">
        {sections.map((section, sectionIndex) => (
          <NavSection
            key={
              // eslint-disable-next-line @eslint-react/no-array-index-key -- Preserve existing behavior while enabling the rule globally.
              section.title || `section-${sectionIndex}`
            }
            title={section.title}
          >
            {section.items.map((item, itemIndex) =>
              'onAction' in item ? (
                <NavActionItem
                  key={
                    // eslint-disable-next-line @eslint-react/no-array-index-key -- Preserve existing behavior while enabling the rule globally.
                    `${item.title}-${sectionIndex}-${itemIndex}`
                  }
                  {...item}
                />
              ) : (
                <NavItem
                  key={
                    // eslint-disable-next-line @eslint-react/no-array-index-key -- Preserve existing behavior while enabling the rule globally.
                    `${item.title}-${sectionIndex}-${itemIndex}`
                  }
                  {...item}
                />
              )
            )}
          </NavSection>
        ))}
      </ul>
    </nav>
  );
}
